import debug from "debug";
import * as THREE from "three";

const log = debug("app:mkprt");

/**
 * MakeControl class responsible for fetching data and creating an object representation.
 * @category Experience
 * @subcategory World
 */
export default class MakeControl {
  /**
   * Constructor for MakeControl.
   * 
   * @param {Object} experience - The main application experience object.
   * @param {THREE.Object3D} ctlProspect - The control prospect object with position and user data.
   */
  constructor(experience, ctlProspect) {
    this.experience = experience;
    this.dataVault = experience.dataVault;
    this.eventHub = experience.eventHub;
    this.ctlProspect = ctlProspect;
  }

  cleanup() {
    this.experience = null;
    this.dataVault = null;
    this.eventHub = null;
    this.ctlProspect = null;
}

  /**
   * Fetches data related to the control prospect and creates an object.
   * 
   * @returns {Promise<Object|null>} - Returns the created object or null if data is not found.
   */
  async fetchDataAndCreateObject() {
    try {
      let ctlBoard = this.ctlProspect.userData.ctlBoard;
      log("ctlProspect", ctlBoard);
      let ctlData = await this.dataVault.fetchDataIfNeeded("parts", ctlBoard);
      if (!ctlData && ctlBoard.endsWith("-SP")) {
        ctlBoard = ctlBoard.slice(0, -3); // Remove the last 3 characters ("-SP")
        ctlData = await this.dataVault.fetchDataIfNeeded("parts", ctlBoard);
      }
      if (ctlData) {
        return this.createXmdObject(ctlData);
      }
    } catch (error) {
      console.error("Error fetching data for ctlProspect:", error);
    }
    return null;
  }

  /**
   * Creates an XMD object representation using fetched control data.
   * 
   * @param {Object} ctlData - The control data retrieved from the database.
   * @returns {Object} - The structured XMD object.
   */
  createXmdObject(ctlData) {
    log("creating xmd object with ctlData", ctlData);
    return {
      partData: {
        mode: "xm-part",
        category: ctlData.catId,
        fullpartnumber: ctlData.id,
      },
      x: this.ctlProspect.position.x,
      z: this.ctlProspect.position.z,
      angle: this.getRotationAngleInDegrees(this.ctlProspect), // Set angle in degrees
    };
  }

  /**
   * Computes the rotation angle of the object in degrees.
   * 
   * @param {THREE.Object3D} object - The Three.js object with a quaternion rotation.
   * @returns {number} - The rotation angle in degrees, rounded to the nearest integer.
   */
  getRotationAngleInDegrees(object) {
    const euler = new THREE.Euler().setFromQuaternion(object.quaternion, "YXZ");
    const angle = THREE.MathUtils.radToDeg(euler.y); // Convert radians to degrees
    const roundedAngle = Math.round(angle); // Round the angle
    log("this is CTL angle", roundedAngle);
    return roundedAngle;
  }
}
